<div class="p-grid">
    <div class="p-col-12 p-lg-2 p-md-2">
        <p-button label="Go Back" styleClass="fullwidthbtn" (click)="navBack()"></p-button>
    </div>
    <div class="p-col-12">
        <div class="card">
            <p-table *ngIf="transaction.length>0"
                     styleClass="p-datatable-items"
                     [value]="transaction"
                     dataKey="fid">
                <ng-template pTemplate="caption">
                    <div class="table-header">
                        Transaction {{transactionId}}
                    </div>
                </ng-template>
                <ng-template pTemplate="body" let-field>
                    <tr class="p-col-12">
                        <td class="p-col-4"><strong>{{field.name}}</strong></td>
                        <td class="p-col-8">{{formatValue(field)}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
